<template lang="pug">
.timeline-chart(v-if='seriesData')
    apexchart(
        type='rangeBar',
        :height='setChartHeight()'
        :options="chartOptions",
        :series="seriesData"
    )
</template>

<script>
import moment from 'moment';

export default {

    name: 'TimelineChartComponent',

    components: {
    },

    props: {

        seriesData: {
            type: Array,
            default: () => ([{
                name: null,
                data: []
            }]),
        },

        optionData: {
            type: Array,
            default: null
        },
    },

    data() {
        return {
            chartOptions: {
                fill: {
                    type: 'solid',
                    opacity: 0.6
                },
                chart: {
                    locales: [...this.setLocale()],
                    defaultLocale: 'pt',
                    toolbar: {
                        show: true,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: 'cronograma',
                                columnDelimiter: ';',
                                headerCategory: 'category',
                                headerValue: 'datetime',
                                dateFormatter(timestamp) {
                                    return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: 'cronograma',
                            },
                            png: {
                                filename: 'cronograma',
                            }
                        },
                        autoSelected: 'zoom'
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        distributed: true,
                        rangeBarGroupRows: true,
                        // barHeight: '50%',
                        dataLabels: {
                            hideOverflowingLabels: false
                        }
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'left',
                    onItemHover: {
                        highlightDataSeries: true
                    },
                    onItemClick: {
                        toggleDataSeries: true
                    },
                    labels: {
                        colors: undefined,
                        useSeriesColors: true
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, opts) {
                        var label = opts.w.globals.labels[opts.dataPointIndex];
                        var a = moment(val[0]);
                        var b = moment(val[1]);
                        var diff = b.diff(a, 'days');

                        var trunc = Math.round((diff / 365) * 10) / 10;
                        // if (diff > 365) return label + ': ' + trunc + (diff > 365 ? ' anos' : 'ano');
                        // return label + ': ' + diff + (diff > 1 ? ' dias' : ' day');
                        if (diff > 365) return trunc + (diff > 365 ? ' anos' : 'ano');
                        return diff + (diff > 1 ? ' dias' : ' dia');
                    },
                    style: {
                        colors: ['white']
                    },
                    dropShadow: {
                        enabled: true,
                    }
                },
                xaxis: {
                    type: 'datetime',
                    position: 'top',
                    //     labels: {
                    //         style: {
                    //             colors: ["red"],
                    //         },
                    //     },
                },
                yaxis: {
                    show: true,
                    type: 'category,datetime,datetime'
                },
                grid: {
                    borderColor: '#111',
                    strokeDashArray: 2,
                    row: {
                        colors: ['#e5e5e5', 'transparent'],
                        opacity: 0.5
                    },
                    column: {
                        colors: ['#f8f8f8', 'transparent'],
                    },
                    xaxis: {
                        lines: {
                            show: true
                        }
                    }
                }
            },

        };
    },

    methods: {
        setChartHeight() {
            return (this.seriesData && this.seriesData?.length + 1) * 80;
        },

        setLocale() {
            let pt = require("apexcharts/dist/locales/pt.json");
            return [pt]
        }
    },

};
</script>
